import { Group, Select, Stack, TextInput } from '@mantine/core';
import { UseFormReturnType as Form } from '@mantine/form';
import QuestionMarkTooltip from 'components/QuestionMarkTooltip';
import { PredefinedDataTypeSelect } from 'components/selects/PredefinedDataTypeSelect';
import { IAutomationGatherConfirmation } from 'pages/revisions-module/template-editor/editors/pipeline/types';
import { useTemplateEditorData } from 'pages/revisions-module/template-editor/TemplateEditorDataProvider';
import { useEffect } from 'react';
import { UserMultiSelect } from 'components/selects/UserSelect';

export const GATHER_CONFIRMATION_TYPES = [{ value: 'digital-signature', label: 'Digitálny podpis' }];

/**
 * Sub-form for gather confirmation automation.
 */
export default function GatherConfirmationSubForm({ form }: { form: Form<IAutomationGatherConfirmation> }) {
  const { deviceType } = useTemplateEditorData();

  useEffect(() => {
    if (!form.values.confirmationType) {
      form.setFieldValue('confirmationType', 'digital-signature');
    }
  }, [form.values.confirmationType]);

  return (
    <>
      <Select
        data={GATHER_CONFIRMATION_TYPES}
        label="Typ potvrdenia"
        required
        searchable
        defaultValue="digital-signature"
        size="sm"
        {...form.getInputProps('confirmationType')}
      />
      <TextInput label="Názov potvrdenia (osoba)" required {...form.getInputProps('label')} />
      <Stack spacing={4}>
        <PredefinedDataTypeSelect
          label={
            <Group spacing={8}>
              Výber z číselníku (nepovinné)
              <QuestionMarkTooltip label="Číselník bude použitý pre odporúčanie mien osôb pri potvrdení" />
            </Group>
          }
          searchable
          size="sm"
          deviceTypeId={deviceType.id}
          placeholder="Bez číselníka"
          {...form.getInputProps('dataType')}
        />
      </Stack>
      <Stack spacing={4}>
        <UserMultiSelect
          label={
            <Group spacing={8}>
              Používatelia s obídením potvrdenia (nepovinné)
              <QuestionMarkTooltip label="Títo používatelia nebudú musieť uviesť potvrdenie" />
            </Group>
          }
          searchable
          size="sm"
          showDiscarded={false}
          placeholder="Žiadni používatelia"
          value={(form.values.bypassUserIds ?? []).map(String)}
          onChange={(values) => form.setFieldValue('bypassUserIds', values.map(Number))}
          error={form.errors['bypassUserIds']}
        />
      </Stack>
    </>
  );
}
